import React from 'react';
import './App.css';
import '98.css';
import Desktop from "./components/desktop";
import Loading from "./components/loading";
import myComputer from "./assets/mycomputer.png";
import myDocuments from "./assets/myDocuments.png";
import tree from "./assets/tree.png";
import iexplorer from "./assets/iexplorer.png";
import mspaint from "./assets/mspaint.png";
import minesweeper from "./assets/minesweeper.png";
import msdocument from "./assets/msdocument.png";
import bin from "./assets/bin.png";
import GeneralModal from "./components/modal/GeneralModal";
import ToSApp from "./components/modal/Applications/ToSApp";
import JSPaintApp from "./components/modal/Applications/JSPaintApp";
import MinesweeperApp from "./components/modal/Applications/Minesweeper/MinesweeperApp";

function MainApp() {
  const [open, setOpen] = React.useState(false);
  const handleShopOpen = (agreement: boolean) => {
        setOpen(agreement);
  }

    return (
        <div className="MainApp">
            {!open ? (
                <Loading openHandle={handleShopOpen} />
            ) : (
                <Desktop />
            )}
        </div>
    );
}

interface IApp {
    name: string;
    icon: string;
    id: string;
    component?: JSX.Element;
}

export const appArray: IApp[] = [
    {
        name: "My Computer",
        icon: myComputer,
        id: "myComputer",
        component: <GeneralModal id={'myComputer'} />
    },
    {
        name: "My 420 Documents",
        icon: myDocuments,
        id: "myDocuments",
        component: <GeneralModal id={'myDocuments'} />
    },
    {
        name: "Dope Shop",
        icon: tree,
        id: "dopeShop",
        component: <GeneralModal id={'dopeShop'} />
    },
    {
        name: "Internet Explorer",
        icon: iexplorer,
        id: "internetExplorer",
        component: <GeneralModal id={'internetExplorer'} />
    },
    {
        name: "Microsoft Paint",
        icon: mspaint,
        id: "mspaint",
        component: <JSPaintApp />
    },
    {
        name: "Minesweeper",
        icon: minesweeper,
        id: "minesweeper",
        component: <MinesweeperApp />
    },
    {
        name: "Terms of Service",
        icon: msdocument,
        id: "tos",
        component: <ToSApp />
    },
    {
        name: "Recycle bin",
        icon: bin,
        id: "bin",
        component: <GeneralModal id={'bin'} />
    }
];
export default MainApp;
